export class Cliente {
    idCliente: number;
    razonSocial: string;
    idPadre: number;
    hijos: Cliente[];
    tipoNodo: number;
    nombre: string;
    niceName: string;
    direccion: string;
    telefono: string;
    ciudad: string;
    pais: string;
    idCultura: number;
    locale: string;
    licencias: number;
    licenciasHabilitadas: number;
    monedaPivote: any;
    formulas: any;
    variablesLocales: any;
    fechaMinima: Date;
    fechaCorte: Date;
    usaArbolPropio: boolean;
    usaDatosPat: number;
    jerarquia: string;
    urlInicial: string;
    idClienteGeneral: number;
    idNegocio: number;

    constructor(params = null) {
        if (params) {
            this.idCliente = params.idCliente;
            this.razonSocial = params.razonSocial;
            this.idPadre = params.idPadre;
            this.hijos = params.hijos;
            this.tipoNodo = params.tipoNodo;
            this.nombre = params.nombre;
            this.niceName = params.niceName;
            this.direccion = params.direccion;
            this.telefono = params.telefono;
            this.ciudad = params.ciudad;
            this.pais = params.pais;
            this.idCultura = params.idCultura;
            this.locale = params.locale;
            this.licencias = params.licencias;
            this.licenciasHabilitadas = params.licenciasHabilitadas;
            this.monedaPivote = params.monedaPivote;
            this.formulas = params.formulas;
            this.variablesLocales = params.variablesLocales;
            this.fechaMinima = params.fechaMinima;
            this.fechaCorte = params.fechaCorte;
            this.usaArbolPropio = params.usaArbolPropio;
            this.usaDatosPat = params.usaDatosPat;
            this.jerarquia = params.jerarquia;
            this.urlInicial = params.urlInicial;
            this.idClienteGeneral = params.idClienteGeneral ? params.idClienteGeneral : undefined;
            this.idNegocio = params.idNegocio ? params.idNegocio : undefined;
        }
    }
}